import React, { useState } from "react"

const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.content

const inputCls =
  "w-full rounded border border-gray-300 dark:border-gray-700 px-3 py-2 text-sm text-gray-700 dark:text-gray-300 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 disabled:opacity-50"
const selectCls =
  "rounded border border-gray-300 dark:border-gray-700 px-2 py-2 text-sm text-gray-700 dark:text-gray-300 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 disabled:opacity-50"
const submitBtn =
  "rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700 disabled:opacity-50 disabled:cursor-not-allowed"

// Invites a new member by email and prepends the returned row to the team list.
export function InviteMemberForm({ membershipsPath, onInvited, roles, copy }) {
  const [email, setEmail] = useState("")
  const [role, setRole] = useState("member")
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)

  const submit = async (e) => {
    e.preventDefault()
    if (busy || !email.trim()) return
    setBusy(true)
    setError(null)
    setSuccess(false)
    try {
      const res = await fetch(membershipsPath, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken(),
          Accept: "application/json",
        },
        body: JSON.stringify({ membership: { email: email.trim(), role } }),
      })
      if (res.ok) {
        const member = await res.json()
        onInvited(member)
        setEmail("")
        setRole("member")
        setSuccess(true)
      } else {
        const body = await res.json().catch(() => ({}))
        setError(body.errors?.[0] || copy.errorGeneric)
      }
    } catch {
      setError(copy.errorGeneric)
    } finally {
      setBusy(false)
    }
  }

  return (
    <form onSubmit={submit} className="space-y-3 rounded-xl border border-gray-200 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50 p-4">
      <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100">{copy.invite.heading}</h3>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-end">
        <label className="flex-1">
          <span className="mb-1 block text-xs font-medium text-gray-500 dark:text-gray-400">{copy.invite.emailLabel}</span>
          <input
            type="email"
            required
            value={email}
            disabled={busy}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={copy.invite.emailPlaceholder}
            className={inputCls}
          />
        </label>
        <label>
          <span className="mb-1 block text-xs font-medium text-gray-500 dark:text-gray-400">{copy.invite.roleLabel}</span>
          <select value={role} disabled={busy} onChange={(e) => setRole(e.target.value)} className={selectCls}>
            <option value="member">{roles.member}</option>
            <option value="admin">{roles.admin}</option>
          </select>
        </label>
        <button type="submit" disabled={busy} className={submitBtn}>
          {busy ? copy.invite.submitting : copy.invite.submit}
        </button>
      </div>
      {error && <p className="text-xs text-red-600 dark:text-red-400">{error}</p>}
      {success && <p className="text-xs text-green-600 dark:text-green-400">{copy.invite.success}</p>}
    </form>
  )
}
